import React from "react";
import { Bar } from 'react-chartjs-2';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Explore from "@material-ui/icons/Explore";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import capExResWelcomeStyle from "assets/jss/material-kit-pro-react/views/capabilityExplorerResultsPageSections/capExResWelcomeStyle.jsx";

class CapExResBarChartSection extends React.Component {
  
  render() {
    console.log('dataD1', this.props.answers);
    let dataD1 = this.props.answers.D1.map(item => item.question.score);
    console.log('dataD1-2', dataD1);
    const chartOptions = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              max: 4,
              display: false
            },
            gridLines: {
              drawBorder: true,
              display: false
            }
          }
        ],
        xAxes: [
          {
            barPercentage: 0.4,
            gridLines: {
              drawBorder: true,
              display: false
            }
          }
        ]
      },
      maintainAspectRatio: false
    };
    const chartData = {
      labels: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6"
      ],
      datasets: [
        {
          label: 'My First dataset',
          backgroundColor: 'rgba(255,99,132,0.2)',
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: dataD1
          // lineTension: 0.2
          // backgroundColor: ["#007F7B"],
        }
      ]
    };
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={10} >
            <h2 className={classes.title}>BAR SECTION</h2>
            <h5 className={classes.description}>
              Nice Looking Chart
            </h5>
            <div style={{ height: "200px", width: "300px" }}>
              <Bar
                data={chartData}
                options={chartOptions}
              />
              </div>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(capExResWelcomeStyle)(CapExResBarChartSection);
